<kno2-dialog-body>
    @if (error()) {
        <kno2-notification-alert
            type="danger"
            [title]="error()"
            (dismiss)="error.set(null)"></kno2-notification-alert>
    }

    <div class="form-group row">
        <p>
            Your organization uses
            <strong>{{ brandDisplayName() }}</strong>
            , a Kno2 Connected&reg; partner providing access to national healthcare networks for patient information exchange. To activate your account, your
            designated Business Administrator must complete identity verification through CLEAR.
        </p>
        <p><strong>Before you begin:</strong></p>
        <p>
            As the designated Business Administrator for {{ brandDisplayName() }},
            <strong>you'll need to have a passport or a state issued photo ID and a cell phone with a camera</strong>
            . The verification process only takes a few minutes.
        </p>
        <p><strong>Why we require this:</strong></p>
        <p>
            To activate your organization for secure healthcare communication with other healthcare organizations and patients, federal regulations (including
            HIPAA) and policy require us to verify the identity of your designated Business Administrator. This step ensures that only authorized individuals
            can represent and manage your organization.
        </p>
        <p>
            You'll be securely redirected to CLEAR, our trusted identity verification partner, who will confirm your identity by matching your government-issued
            ID with a quick selfie on your cell phone.
        </p>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        class="clear-button"
        type="button"
        [disabled]="isSubmitting()"
        (click)="startIdentityProofing()">
        @if (isSubmitting()) {
            <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
            Redirecting to CLEAR&hellip;
        } @else {
            <img
                class="clear-logo"
                src="/images/clear-logo.png"
                alt="CLEAR" />
            Continue with CLEAR
        }
    </button>
</kno2-dialog-footer>
